import { Droplet, ShieldCheck, Users, AlertTriangle } from "lucide-react";
import { THC } from "@/lib/tankHealthCheck";

const TRUST = [
  [Droplet, "LOCAL EXPERTS", "Sunshine Coast"],
  [ShieldCheck, "INDEPENDENT TESTING", "Real answers"],
  [Users, "HEALTHIER HOMES", "For our community"],
];

export function TrustStrip() {
  return (
    <section className="bg-white border-y" style={{ borderColor: THC.border }} data-testid="thc-trust-strip">
      <div className="mx-auto max-w-[1440px] px-[18px] md:px-7 xl:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 sm:divide-x" style={{ borderColor: THC.border }}>
          {TRUST.map(([Icon, title, sub]) => (
            <div key={title} className="flex items-center gap-3 py-4 sm:py-5 sm:px-6 first:sm:pl-0"
              style={{ borderColor: THC.border }} data-testid={`thc-trust-${title.toLowerCase().replace(/\s+/g, "-")}`}>
              <Icon className="w-[28px] h-[28px] shrink-0" style={{ color: THC.blue }} aria-hidden="true" />
              <div className="leading-tight">
                <div className="text-[13px] xl:text-[14px] font-bold uppercase tracking-wide" style={{ color: THC.navy }}>{title}</div>
                <div className="text-[13px] xl:text-[14px]" style={{ color: THC.muted }}>{sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function OwnerBanner() {
  return (
    <section className="mx-auto max-w-[1440px] px-[18px] md:px-7 xl:px-10 pt-6" data-testid="thc-owner-banner">
      <div className="rounded-[13px] px-5 py-4 md:py-5 flex flex-col md:flex-row md:items-center gap-3 md:gap-6"
        style={{ backgroundColor: THC.yellow, boxShadow: "0 6px 20px rgba(245,183,0,0.28)" }}>
        <div className="flex items-center gap-4">
          <span className="shrink-0 w-[46px] h-[46px] md:w-[52px] md:h-[52px] rounded-full bg-white grid place-items-center">
            <AlertTriangle className="w-[26px] h-[26px] md:w-[30px] md:h-[30px]" style={{ color: THC.yellowInk }} aria-hidden="true" />
          </span>
          <h2 className="font-black uppercase leading-none text-[24px] md:text-[28px] xl:text-[30px]"
            style={{ color: THC.navy, fontFamily: "'Outfit',system-ui,sans-serif" }}>
            OWNER MUST BE PRESENT
          </h2>
        </div>
        <div className="hidden md:block w-px self-stretch bg-[#073A7A]/30" />
        <p className="font-semibold text-[16px] md:text-[18px] xl:text-[19px] leading-[1.35]" style={{ color: THC.navy }}>
          A Pristine Water Systems technician will show you what they find and explain any
          practical next steps.
        </p>
      </div>
    </section>
  );
}
